<template>
  <div>
    <el-card class="box-card" style="min-height: 600px">
      <div slot="header" class="boxHeader">
        <span>资质申请</span>
      </div>

      <el-table :data="cerlistData" ref="scroll" style="min-height: 400px; cursor: pointer" row-key="id"
        @sort-change="handleTableSort" @expand-change="handelRowclick" :expand-row-keys="expands">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column label="" prop="" width="80"> </el-table-column>
              <!-- <el-table-column label="审核人" prop="auditPersonName"> </el-table-column> -->
              <el-table-column label="审核结果" prop="auditResult"> <template slot-scope="scope">
                  <span v-if="scope.row.auditResult == 1">未提交</span>
                  <span v-if="scope.row.auditResult == 2">审核中</span>
                  <span v-if="scope.row.auditResult == 3">审核通过</span>
                  <span v-if="scope.row.auditResult == 0">审核不通过</span>
                </template> </el-table-column>
              <el-table-column label="原因" prop="auditMemo"> </el-table-column>
              <el-table-column label="时间" prop="auditTime"> 
                <template slot-scope="scope">
                 <span>{{ scope.row.auditTime }}</span>
                </template> 
              </el-table-column>
              
            </el-table>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="cerNum" label="申请编号" show-overflow-tooltip align="center">
        </el-table-column> -->
        <el-table-column prop="userName" label="姓名" show-overflow-tooltip width="150" align="center">
        </el-table-column>
        <el-table-column prop="userType" label="申请类型" show-overflow-tooltip min-width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.userType == 1">创新管理咨询师</span>
            <span v-if="scope.row.userType == 2">创新管理实训主持人</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">未提交</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核通过</span>
            <span v-if="scope.row.status == 0">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请日期" width="160" show-overflow-tooltip sortable align="center">
        </el-table-column>
        <el-table-column prop="cerCode" label="操作" width="100">
          <template slot-scope="scope">
            <span @click="editQuity(scope.row)" style="cursor: pointer; color: #409eff; margin-right: 10px"
              v-if="scope.row.status == 1 || scope.row.status == 0">编辑</span>
            <span @click="delCer(scope.row)" style="cursor: pointer; color: red" v-if="scope.row.status == 1">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @size-change="handleSizeChangecer" @current-change="handleCurrentChangecer"
        :current-page="pageCer" :page-sizes="[10, 50, 100, 200]" :page-size="rowsCer"
        layout="total,prev, pager, next, sizes,  jumper" :total="cerlistData.length">
      </el-pagination>
    </el-card>

    <el-dialog title="添加证书" width="40%" top="20vh" :visible.sync="dialogFormVisibles">
      <el-form :model="formAdd" :rules="formAddRules" ref="formAdd">
        <el-form-item label="证书编号" label-width="130px" prop="cerCode">
          <el-input style="width: 60%" v-model="formAdd.cerCode" autocomplete="off" maxlength="50"
            @input="changeCercode" placeholder="请输入证书编号"></el-input>
        </el-form-item>

        <el-form-item label="证书名称" label-width="130px" prop="cerName">
          <el-input style="width: 60%" v-model="formAdd.cerName" autocomplete="off" maxlength="50"
            @input="changeCername" placeholder="请输入证书名称"></el-input>
        </el-form-item>
        <el-form-item label="证书类别" label-width="130px" prop="cerSelect">
          <el-select v-model="formAdd.cerSelect" placeholder="请选择证书类别" style="width: 60%">
            <el-option v-for="(item, index) in cerType" :key="index" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startTime" label-width="130px" label="证书开始时间">
          <el-date-picker v-model="formAdd.startTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
            style="width: 60%">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" label-width="130px" label="证书结束时间">
          <el-date-picker v-model="formAdd.endTime" value-format="yyyy-MM-dd" type="date" clearable placeholder="选择日期"
            style="width: 60%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addNo">取 消</el-button>
        <el-button type="primary" @click="addCerfrom" :disabled="disablecer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addPersonCer, getDictInfoNew, delCers, queryAuditList } from "@/api/api.js";
export default {
  name: "",
  components: {},
  props: {
    cerlistData: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: Number || String,
      default: null,
    },
  },
  data() {
    return {
      pageCer: 1,
      rowsCer: 10,
      totalCer: 0,
      dialogFormVisibles: false,
      disablecer: false,
      formAddRules: {
        cerCode: [
          {
            required: true,
            message: "请输入证件编号",
            trigger: ["blur", "change"],
          },
        ],
        cerName: [
          {
            required: true,
            message: "请输入证件名称",
            trigger: ["blur", "change"],
          },
        ],
        cerSelect: [
          {
            required: true,
            message: "请选择证件类别",
            trigger: ["blur", "change"],
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择证书开始时间",
            trigger: ["blur", "change"],
          },
        ],
        // endTime: [
        //   {
        //     required: true,
        //     message: "请选择证书结束时间",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        fileCert: [
          {
            required: true,
            message: "请上传证书",
            trigger: ["blur", "change"],
          },
        ],
      },
      formAdd: {
        cerCode: "",
        cerName: "",
        cerSelect: "",
        startTime: "",
        endTime: "",
        fileCert: [],
      },
      cerType: [],
      tableData: [],
      expands:[]
    };
  },
  computed: {},
  watch: {
    // activeIndex(new){
    //     // if(new == 5){
    //     // }
    // }
  },
  created() { },
  mounted() {
    getDictInfoNew("ZSLB").then((res) => {
      this.cerType = res.data;
    });
  },
  methods: {
    handelRowclick(row, expandedRows) {
      this.expands = [];
    if (expandedRows.length > 0) {
      row ? this.expands.push(row.id) : '';
    }
      queryAuditList(this.$qs.stringify({ reviewedPersonId: row.id })).then(res => {
        // console.log(res)
        if (res.code == "1000") {
          this.tableData = res.data
        }

      })
    },
    handleTableSort({ column, prop }) {
      console.log(column.label);
      if (column.order == "ascending") {
        let obj = {
          orderByAsc: true,
          orderByColumns: prop,
        };
        this.$emit("handleTableSort", obj);
      } else {
        let obj = {
          orderByAsc: false,
          orderByColumns: prop,
        };
        this.$emit("handleTableSort", obj);
      }
    },
    changeCername(value) {
      this.$forceUpdate();
      this.formAdd.cerName = value.replace(/\s+/g, "");
    },
    changeCercode(value) {
      this.$forceUpdate();
      this.formAdd.cerCode = value.replace(/\s+/g, "");
    },
    // 资质信息
    handleSizeChangecer(val) {
      this.rowsCer = val;
      this.pageCer = 1;
      this.$emit("getCerlistdata", this.rowsCer, this.pageCer);
    },
    //分页 -- 当前页数
    handleCurrentChangecer(val) {
      this.pageCer = val;
      this.$emit("getCerlistdata", this.rowsCer, this.pageCer);
    },
    delCer(row) {
      this.$emit("delCer", row.id);
    },
    editQuity(row) {
      console.log(row)
      // this.dialogFormVisibles = true;
      // sessionStorage.setItem("userInfos", row.id);
      if (row.userType == '1') {
        this.$router.push({
          name: "consultant",
          query: { type: row.status, userInfos: row.id, operStep: row.operStep,status:row.status },
        });
      } else if (row.userType == '2') {
        this.$router.push({
          name: "gameMaster",
          query: { type: row.status, userInfos: row.id, operStep: row.operStep,status:row.status },
        });
      }
    },
    // 确定添加
    addCerfrom() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      this.$refs.formAdd.validate((valid) => {
        if (valid) {
          if (this.formAdd.endTime == null || this.formAdd.endTime == undefined)
            this.formAdd.endTime = "";
          if (this.formAdd.endTime != "") {
            if (this.formAdd.endTime < this.formAdd.startTime) {
              this.$message.error("证书结束时间不能小于证书开始时间");
              return false;
            }
          }
          let data = new FormData();
          data.append("personId", user.id);
          data.append("cerNum", this.formAdd.cerCode);
          data.append("cerName", this.formAdd.cerName);
          data.append("cerType", this.formAdd.cerSelect);
          data.append("startTime", this.formAdd.startTime);
          data.append("endTime", this.formAdd.endTime);
          data.append("cerImage", this.formAdd.fileCert[0]);
          this.disablecer = true;
          addPersonCer(data).then((res) => {
            if (res.code == 1000) {
              this.dialogFormVisibles = false;
              this.getCerlist();
              this.$refs.formAdd.resetFields();
              this.$message.success("新增成功");
              this.disablecer = false;
            } else {
              this.$message.error(res.msg);
              this.disablecer = false;
            }
          });
        }
      });
    },
    addNo() {
      this.dialogFormVisibles = false;
      this.$refs.formAdd.resetFields();
    },
  },
};
</script>

<style scoped lang="less">
.boxHeader:before,
.boxHeader:after {
  display: table;
  content: "";
}

.boxHeader:after {
  clear: both;
}

.box-card {
  width: 898px;
  margin: 0 20px;
  padding: 0 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  // overflow:auto;

  .boxHeader {
    span {
      float: left;
      padding: 10px 0;
      font-size: 16px;
    }

    .el-button {
      float: right;
      width: 80px;
      height: 36px;
      background: #5780f2;
      border-radius: 6px;
    }
  }

  .avatar-uploader {
    float: left;
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  .el-upload {
    position: relative;
  }

  .el-icon-error {
    position: absolute;
    right: 3px;
    top: 3px;
    z-index: 9;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 2px #333;
  }

  ::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  ::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  ::v-deep .avatar-uploader-icon {
    width: 70px;
    height: 80px;
    line-height: 80px;
  }

  .el-input {
    // display: flex;
    width: 100%;
  }

  ::v-deep .el-input__inner {
    display: flex;
    // width: 100%;
    // background-color: #f2f6fd;
    // height: 36px;
  }

  ::v-deep .el-range-editor .el-range-input {
    // background-color: #f2f6fd;
    cursor: pointer;
  }

  ::v-deep .el-textarea__inner {
    // background-color: #f2f6fd;
    // color: #606266;
    font-family: 微软雅黑;
    min-height: 80px !important;
  }

  // ::v-deep .el-textarea .el-input__count {
  //   background-color: #f2f6fd;
  //   color: #000;
  //   bottom: 2px;
  //   right: 18px;
  // }
  ::v-deep .el-card__header {
    padding: 10px 20px;
  }

  .el-form-item {
    margin-bottom: 20px;
    width: 60%;
  }
}

::v-deep .el-table th.el-table__cell {
  background: #f5f5f5;
  color: #000;
}

::v-deep .el-pagination {
  text-align: right;
  margin-top: 20px;
}
</style>
